export enum AudienceMetadataField {
  AdditionalQuestions = 'Item.additionalQuestions',
  PrimaryQuestion = 'Item.primaryQuestion',
  TopicCategory = 'Item.topicCategory',
  AdditionalTopicCategory = 'Item.additionalTopicCategory',
  AdditionalFunctions = 'Item.additionalFunctions',
  AdditionalRoles = 'Item.additionalRoles',
  RolePriority = 'Item.rolePriority',
  Function = 'Item.function',
  PrimaryRolePriority = 'Item.primaryRolePriority',
  PrimaryPriorityJourneyStep = 'Item.primaryPriorityJourneyStep'
}

export const AudienceMetadataHiddenFields = [
  AudienceMetadataField.AdditionalQuestions,
  AudienceMetadataField.TopicCategory,
  AudienceMetadataField.AdditionalTopicCategory,
  AudienceMetadataField.AdditionalFunctions,
  AudienceMetadataField.AdditionalRoles,
  AudienceMetadataField.RolePriority,
  AudienceMetadataField.PrimaryRolePriority,
  AudienceMetadataField.PrimaryPriorityJourneyStep
];
